// routes
import { Settings } from '@material-ui/icons';
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/static/icons/navbar/${name}.svg`}
    sx={{ width: 22, height: 22 }}
  />
);

const ICONS = {
  page: getIcon('ic_page'),
  dashboard: getIcon('ic_dashboard')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'menu',
    items: [
      {
        title: 'Home',
        href: PATH_DASHBOARD.general.pageOne,
        icon: ICONS.page
      },
      {
        title: 'Past Bookings',
        href: PATH_DASHBOARD.general.pastBookings,
        icon: ICONS.page
      },
       /*
      {
        title: 'Timetable',
        href: PATH_DASHBOARD.general.timeTablePage,
        icon: <DepartureBoard/>
      },
      */
      {
        title: 'My Settings',
        href: PATH_DASHBOARD.general.configPage,
        parentOnly:true,
        icon: <Settings/>
      }
    ]
  }
];

export const sidebarConfigStaff = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'menu',
    items: [
      {
        title: 'Bookings',
        href: PATH_DASHBOARD.general.pageOne,
        icon: ICONS.page
      },
      {
        title: 'Past Bookings',
        href: PATH_DASHBOARD.general.pastBookings,
        icon: ICONS.page
      },
      /*
      {
        title: 'Timetable',
        href: PATH_DASHBOARD.general.timeTablePage,
        icon: <DepartureBoard/>
      },
      */
    ]
  }
];

export const sidebarConfigStudent = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'menu',
    items: [
      {
        title: 'Bookings',
        href: PATH_DASHBOARD.general.pageOne,
        icon: ICONS.page
      },
      {
        title: 'Past Bookings',
        href: PATH_DASHBOARD.general.pastBookings,
        icon: ICONS.page
      },
    ]
  }
];


export default sidebarConfig;
